import { EmptySpaceFiller, GroupLabel } from './SharedGroupRuleElements';
import { TextInput } from '@ardoq/forms';
import { GroupType } from '@ardoq/api-types';
import { ParentAllGroupingRule, PerspectiveGroupingRule } from '../types';
import { ReactElement } from 'react';
import { type I18nLocale, t } from '@ardoq/i18n';

type ParentAllGroupRuleProps = {
  groupingRule: ParentAllGroupingRule;
  onGroupingRuleUpdated: (
    groupingRuleId: string,
    updatedGroupingRule: Partial<PerspectiveGroupingRule>
  ) => void;
  ruleHeader?: ReactElement;
  tabIndex?: number;
  i18nLocale: I18nLocale;
};

const ParentAllGroupRule = ({
  groupingRule,
  onGroupingRuleUpdated,
  ruleHeader,
  tabIndex,
  i18nLocale,
}: ParentAllGroupRuleProps) => {
  const updateGroupRuleLabel = (newLabel: string) =>
    onGroupingRuleUpdated(groupingRule.id, {
      sublabel: newLabel,
    });
  return (
    <>
      {ruleHeader ? (
        ruleHeader
      ) : (
        <>
          <GroupLabel data-testid={`group-by-${GroupType.PARENT_ALL}-label`}>
            {t(
              i18nLocale,
              'perspectives:groupingRules.parentAllLabel',
              'Parent all'
            )}
          </GroupLabel>
          <EmptySpaceFiller />
          <EmptySpaceFiller />
          <EmptySpaceFiller />
        </>
      )}
      <TextInput
        dataTestId="parent-all-grouping-rule-sublabel-input"
        value={groupingRule.sublabel}
        onValueChange={updateGroupRuleLabel}
        tabIndex={tabIndex}
      />
    </>
  );
};

export { ParentAllGroupRule };
